import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentLoaderComponent } from './component-loader.component';
import { ComponentLoaderDirective } from './component-loader.directive';

@NgModule({
  imports: [CommonModule, ComponentLoaderComponent, ComponentLoaderDirective],
  exports: [ComponentLoaderComponent],
})
export class ComponentLoaderModule {}
